import { render, staticRenderFns } from "./TaskSettingsPrimaryInfo.vue?vue&type=template&id=5b39fe16&"
import script from "./TaskSettingsPrimaryInfo.vue?vue&type=script&lang=js&"
export * from "./TaskSettingsPrimaryInfo.vue?vue&type=script&lang=js&"
import style0 from "./TaskSettingsPrimaryInfo.vue?vue&type=style&index=0&module=true&lang=less&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./TaskSettingsPrimaryInfo.vue?vue&type=style&index=0&module=true&lang=less&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./TaskSettingsPrimaryInfo.vue?vue&type=style&index=0&module=true&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("5b39fe16")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b39fe16')) {
      api.createRecord('5b39fe16', component.options)
    } else {
      api.reload('5b39fe16', component.options)
    }
    module.hot.accept("./TaskSettingsPrimaryInfo.vue?vue&type=template&id=5b39fe16&", function () {
      api.rerender('5b39fe16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/taskSettings/sections/primaryInfo/TaskSettingsPrimaryInfo.vue"
export default component.exports